import React from 'react'
import { func } from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { Row, Col } from '@gympass/yoga'

import Form from '../../components/Form'

import * as Style from './Main.style'

export default function Main({ handleForm, setFunnelStage }) {
  return (
    <Style.MainWrapper>
      <Style.HeaderWrapper />

      <Style.CardWrapper>
        <Row>
          <Col xxs={12} xl-start={3} xl={8}>
            <Style.FormWrapper>
              <Style.FormTitle>
                <FormattedMessage id="smb_acquisition_company_info.main_form.header.title" />
              </Style.FormTitle>

              <Style.FormSubtitle>
                <FormattedMessage id="smb_acquisition_company_info.main_form.header.subtitle" />
              </Style.FormSubtitle>

              <Form onSubmit={handleForm} setFunnelStage={setFunnelStage} />

              <Style.FormFooter>
                <FormattedMessage id="smb_acquisition_company_info.main_form.footer.advise" />
              </Style.FormFooter>
            </Style.FormWrapper>
          </Col>
        </Row>
      </Style.CardWrapper>
    </Style.MainWrapper>
  )
}

Main.propTypes = {
  handleForm: func.isRequired,
  setFunnelStage: func.isRequired,
}
